/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v2.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import Buttons from "views/Components/Buttons.js";
import GridSystem from "views/Components/GridSystem.js";
import Panels from "views/Components/Panels.js";
import SweetAlert from "views/Components/SweetAlertPage.js";
import Notifications from "views/Components/Notifications.js";
import Icons from "views/Components/Icons.js";
import Typography from "views/Components/Typography.js";
import RegularForms from "views/Forms/RegularForms.js";
import ExtendedForms from "views/Forms/ExtendedForms.js";
import ValidationForms from "views/Forms/ValidationForms.js";
import Wizard from "views/Forms/Wizard/Wizard.js";
import RegularTables from "views/Tables/RegularTables.js";
import ExtendedTables from "views/Tables/ExtendedTables.js";
import ReactTables from "views/Tables/ReactTables.js";
import Charts from "views/Charts.js";
import Calendar from "views/Calendar.js";
import UserPage from "views/Pages/UserPage.js";
import LoginPage from "views/Pages/LoginPage.js";
import Login from "views/Pages/Auth/Login.js";
import RegisterPage from "views/Pages/RegisterPage.js";
import ForgotPassword from "views/Pages/Auth/ForgotPassword.js";
import ResetPassword from "views/Pages/Auth/ResetPassword.js";
import LockScreenPage from "views/Pages/LockScreenPage.js";

// SAAS Components
import Dashboard from "views/Pages/Dashboard/Dashboard.js";
// import Contact from "views/Pages/Contacts/Contact.js";
import PhoneNumbers from "views/Pages/PhoneNumbers/PhoneNumbers.js";
import Billing from "views/Pages/Billing/Billing.js";
import PaymentMethod from "views/Pages/Billing/PaymentMethod.js";
import User from "views/Pages/User.js";
import Campaigns from "views/Pages/Campaign/Campaigns.js";
import CreateCampaign from "views/Pages/Campaign/CreateCampaign.js";
import CampaignProgress from "views/Pages/Campaign/CampaignProgress.js";
import P2PSender from "views/Pages/Campaign/P2PSender.js";
import CustomFields from "views/Pages/CustomFields/CustomFields.js";
import Users from "views/Pages/Users/Users.js";
import Settings from "views/Pages/Profile/Settings.js";
import ContactLists from "views/Pages/Contacts/ContactLists.js";
import ActivePhoneNumbers from "views/Pages/PhoneNumbers/ActiveNumbers";
import Conversations from "views/Pages/Conversation/ConversationAccess";
import ContactUs from "views/Pages/Support/ContactUs.js";

var routes = [
  {
    path: "/dashboard",
    layout: "/admin",
    name: "Dashboard",
    icon: "fas fa-home", // ✅ updated
    component: Dashboard,
  },
  {
    path: "/users",
    layout: "/admin",
    name: "Users",
    icon: "fas fa-user",
    component: Users,
    roles: ["admin"],
  },
  {
    path: "/custom-fields",
    layout: "/admin",
    name: "Custom Fields",
    icon: "nc-icon nc-align-center",
    component: CustomFields,
  },
  {
    path: "/contact-lists",
    layout: "/admin",
    name: "Contacts",
    icon: "fas fa-users", // ✅ updated
    component: ContactLists,
  },
  {
    path: "/campaign-overview",
    layout: "/admin",
    name: "Campaigns",
    icon: "fas fa-comment-alt",
    component: Campaigns,
  },
  {
    path: "/create-campaign",
    layout: "/admin",
    component: CreateCampaign,
    invisible: true,
  },
  {
    path: "/campaign-progress",
    layout: "/admin",
    component: CampaignProgress,
    invisible: true,
  },
  {
    path: "/campaigns/:id/p2p",
    layout: "/admin",
    component: P2PSender,
    invisible: true,
  },
  {
    path: "/phone-numbers",
    layout: "/admin",
    name: "Phone Numbers",
    icon: "nc-icon nc-mobile",
    component: ActivePhoneNumbers,
  },
  {
    path: "/buy-phone-numbers",
    layout: "/admin",
    component: PhoneNumbers,
    invisible: true,
  },


  {
    path: "/billing",
    layout: "/admin",
    name: "Billing",
    icon: "fas fa-credit-card", // ✅ NEW
    component: Billing,
  },
  {
    path: "/contact-us",
    layout: "/admin",
    name: "Contact Us",
    icon: "fas fa-headset",
    component: ContactUs,
  },
  {
    path: "/payment-Method",
    layout: "/admin",
    name: "Payment Method",
    icon: "nc-icon nc-money-coins",
    component: PaymentMethod,
    invisible: true,
  },
  {
    path: "/conversations",
    layout: "/admin",
    name: "Conversations",
    icon: "fas fa-comments",
    component: Conversations,
    conversationFeature: true,
  }



  /*
  {
    path: "/my-subscriptions",
    layout: "/admin",
    name: "My Subscriptions",
    icon: "nc-icon nc-money-coins",
    component: MySubscriptions,
  },
  {
    path: "/users",
    layout: "/admin",
    name: "Users",
    icon: "nc-icon nc-money-coins",
    component: User,
  },
  {
    collapse: true,
    path: "/components",
    name: "Components",
    state: "openComponents",
    icon: "nc-icon nc-app",
    views: [
      {
        path: "/buttons",
        layout: "/admin",
        name: "Buttons",
        mini: "B",
        component: Buttons,
      },
      {
        path: "/grid-system",
        layout: "/admin",
        name: "Grid System",
        mini: "GS",
        component: GridSystem,
      },
      {
        path: "/panels",
        layout: "/admin",
        name: "Panels",
        mini: "P",
        component: Panels,
      },
      {
        path: "/sweet-alert",
        layout: "/admin",
        name: "Sweet Alert",
        mini: "SA",
        component: SweetAlert,
      },
      {
        path: "/notifications",
        layout: "/admin",
        name: "Notifications",
        mini: "N",
        component: Notifications,
      },
      {
        path: "/icons",
        layout: "/admin",
        name: "Icons",
        mini: "I",
        component: Icons,
      },
      {
        path: "/typography",
        layout: "/admin",
        name: "Typography",
        mini: "T",
        component: Typography,
      },
    ],
  },
  {
    collapse: true,
    path: "/forms",
    name: "Forms",
    state: "openForms",
    icon: "nc-icon nc-notes",
    views: [
      {
        path: "/regular-forms",
        layout: "/admin",
        name: "Regular Forms",
        mini: "RF",
        component: RegularForms,
      },
      {
        path: "/extended-forms",
        layout: "/admin",
        name: "Extended Forms",
        mini: "EF",
        component: ExtendedForms,
      },
      {
        path: "/validation-forms",
        layout: "/admin",
        name: "Validation Forms",
        mini: "VF",
        component: ValidationForms,
      },
      {
        path: "/wizard",
        layout: "/admin",
        name: "Wizard",
        mini: "W",
        component: Wizard,
      },
    ],
  },
  {
    collapse: true,
    path: "/tables",
    name: "Tables",
    state: "openTables",
    icon: "nc-icon nc-paper-2",
    views: [
      {
        path: "/regular-tables",
        layout: "/admin",
        name: "Regular Tables",
        mini: "RT",
        component: RegularTables,
      },
      {
        path: "/extended-tables",
        layout: "/admin",
        name: "Extended Tables",
        mini: "ET",
        component: ExtendedTables,
      },
      {
        path: "/react-table",
        layout: "/admin",
        name: "React Table",
        mini: "RT",
        component: ReactTables,
      },
    ],
  },
  {
    path: "/charts",
    layout: "/admin",
    name: "Charts",
    icon: "nc-icon nc-chart-bar-32",
    component: Charts,
  },
  {
    path: "/calendar",
    layout: "/admin",
    name: "Calendar",
    icon: "nc-icon nc-single-copy-04",
    component: Calendar,
  },
  {
    collapse: true,
    path: "/pages",
    name: "Pages",
    state: "openPages",
    icon: "nc-icon nc-puzzle-10",
    views: [
      {
        path: "/user-page",
        layout: "/admin",
        name: "User Page",
        mini: "UP",
        component: UserPage,
      },
      {
        path: "/login",
        layout: "/auth",
        name: "Login",
        mini: "LP",
        component: Login,
      },
      {
        path: "/ForgotPassword",
        layout: "/auth",
        name: "ForgotPassword",
        mini: "FP",
        component: ForgotPassword,
      },
      {
        path: "/ResetPassword",
        layout: "/auth",
        name: "ResetPassword",
        mini: "RP",
        component: ResetPassword,
      },
      {
        path: "/login-page",
        layout: "/auth",
        name: "Login Page",
        mini: "LP",
        component: LoginPage,
      },

      {
        path: "/register-page",
        layout: "/auth",
        name: "Register",
        mini: "RP",
        component: RegisterPage,
      },
      {
        path: "/lock-screen-page",
        layout: "/auth",
        name: "Lock Screen Page",
        mini: "LSP",
        component: LockScreenPage,
      },
    ],
  },
  */
];
export default routes;
